import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { zoomIconPng } from '../../assets/images';
import { DefaultHeader } from '../../components/DefaultHeader';
import { SITE_LINKS } from '../../constants';
import { Background } from '../../stories/Background';
import { Button } from '../../stories/Button';

interface ZoomInstructionsPageProps {
  data?: {
    downloadUrl?: string;
  };
}

export const ZoomInstructionsPage: React.FC<ZoomInstructionsPageProps> = ({ data }) => {
  const [alreadyDownloaded, setAlreadyDownloaded] = useState(false);
  const __ = useTranslation().t;

  const handleClickDownload = () => {
    setAlreadyDownloaded(true);
  };

  return (
    <>
      <DefaultHeader />
      <Background>
        <div className="oejr-zoom-instructions-page">
          <Container>
            <Row>
              <Col sm={12} md={10} lg={8} xl={7}>
                <div className="oejr-zoom-instructions-header-container">
                  <img src={zoomIconPng} alt="Zoom" />

                  <div>
                    <h2 className="oejr-zoom-instructions-header">{__('zoomAppNeeded')}</h2>
                    <p className="oejr-zoom-instructions-description">{__('liveClassesGuide')}</p>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="row-eq-height">
              <Col sm={12} md={6} lg={4} className="mt-4">
                <div className="oejr-zoom-instructions-card">
                  <span className="oejr-zoom-instructions-card-number">1</span>

                  <h3 className="oejr-zoom-instructions-card-title">{__('downloadZoom')}</h3>
                  <p className="oejr-zoom-instructions-card-description">
                    {__('downloadLatestAppVersion')}
                  </p>
                  <Button
                    target="_blank"
                    href={data?.downloadUrl}
                    onClick={handleClickDownload}
                    label={__('download')}
                    icon="download"
                    variant="primary"
                    outline={alreadyDownloaded}
                    className="oejr-zoom-instructions-card-button"
                  />
                </div>
              </Col>
              <Col sm={12} md={6} lg={4} className="mt-4">
                <div className="oejr-zoom-instructions-card">
                  <span className="oejr-zoom-instructions-card-number">2</span>

                  <h3 className="oejr-zoom-instructions-card-title">{__('installZoom')}</h3>
                  <p className="oejr-zoom-instructions-card-description">
                    {__('zoomInstallInstructions')}
                  </p>
                </div>
              </Col>
              <Col sm={12} md={6} lg={4} className="mt-4">
                <div className="oejr-zoom-instructions-card">
                  <span className="oejr-zoom-instructions-card-number">3</span>

                  <h3 className="oejr-zoom-instructions-card-title">{__('everythingIsReady')}</h3>
                  <p className="oejr-zoom-instructions-card-description">
                    {__('zoomInstalledContinueMessage')}
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
          <div className="oejr-zoom-instructions-footer">
            <Button
              href={SITE_LINKS.HomePage}
              label={__('skipIAlreadyHaveTheApp')}
              variant="link"
              className="oejr-zoom-instructions-footer-skip-button"
            />

            <Button
              disabled={!alreadyDownloaded}
              href={SITE_LINKS.HomePage}
              label={__('continue')}
              variant="primary"
            />
          </div>
        </div>
      </Background>
    </>
  );
};
